<template>
    <DsTable :is-scrollable="true" :is-responsive="true">
        <DsTableRow>
            <DsTableCell type="th">Uhodnutý den</DsTableCell>
            <DsTableCell type="th">Uhodnutý měsíc</DsTableCell>
            <DsTableCell type="th">Uhodnutý rok</DsTableCell>
            <DsTableCell type="th">Vklad</DsTableCell>
            <DsTableCell type="th">Výhra</DsTableCell>
        </DsTableRow>
        <DsTableRow v-if="boardResult">
            <DsTableCell>{{ formatMatchingPrimaryNumbers }}</DsTableCell>
            <DsTableCell>{{ formatMatchingSecondaryNumbers }}</DsTableCell>
            <DsTableCell>{{ formatMatchingTertiaryNumbers }}</DsTableCell>
            <DsTableCell><span v-html="formatNumberWithCurrency(getStake(0))"></span></DsTableCell>
            <DsTableCell><span v-html="formatNumberWithCurrency(boardResult.winAmount)"></span></DsTableCell>
        </DsTableRow>
    </DsTable>
</template>

<script lang="ts" setup>
import DsTable from "@sazka/design-system/src/table/ds-table.vue";
import DsTableRow from "@sazka/design-system/src/table-row/ds-table-row.vue";
import DsTableCell from "@sazka/design-system/src/table-cell/ds-table-cell.vue";
import { TicketCheckResultsBoard } from "@/lotteries/model/ticket-check/ticket-check";
import { StringUtils } from "@sazka/utils/string-utils";
import { useWagerBoardStore } from "../../stores/use-wager-board-store";

const props = defineProps<{
    results: TicketCheckResultsBoard[];
}>();
const EMPTY_CELL_STRING = "–––";
const boardResult = props.results[0];
const wagerStore = useWagerBoardStore();

const getStake = (boardIndex: number) => {
    let stake = wagerStore.boards[boardIndex]?.stake;
    if (wagerStore.multiplier) {
        stake = stake * wagerStore.multiplier;
    }
    return stake;
};

const formatNumberWithCurrency = (amount: number) => {
    if (amount) {
        return StringUtils.formatCurrency(amount);
    }
    return EMPTY_CELL_STRING;
};

const ticketCheckBoard = wagerStore.getBoardsForCheckout;

const formatMatchingPrimaryNumbers = boardResult.matchingPrimary.length
    ? ticketCheckBoard[0].primary[0]
    : EMPTY_CELL_STRING;
const formatMatchingSecondaryNumbers = boardResult.matchingSecondary.length
    ? ticketCheckBoard[0].secondary[0]
    : EMPTY_CELL_STRING;
const formatMatchingTertiaryNumbers = boardResult.matchingTertiary.length
    ? ticketCheckBoard[0].tertiary[0]
    : EMPTY_CELL_STRING;
</script>
